import React from "react";

export default function Icon(props) {
  return(
    <i style={props.style} className={`fas fa-${props.icon}`}></i>
  );
}
